import { render, staticRenderFns } from "./navbar_internal.vue?vue&type=template&id=b2e768a8"
import script from "./navbar_internal.vue?vue&type=script&lang=js"
export * from "./navbar_internal.vue?vue&type=script&lang=js"
import style0 from "./navbar_internal.vue?vue&type=style&index=0&id=b2e768a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports